import { Box, Button, Stack, Tabs } from '@mantine/core';
import { UseFormReturnType } from '@mantine/form';

import { TSDViewConsignmentFormValues } from '@e-origin/contracts';
import { TransitHouseConsignment } from '@e-origin/shared';

import { classes } from '@styles';
import { HouseBatches } from './HouseBatches';
import { HouseCoreData } from './HouseCoreData';
import { HouseDocuments } from './HouseDocuments';
import { HouseStakeholders } from './HouseStakeholders';
import { HouseTransport } from './HouseTransport';
import { useTSDViewHouseFormInitializer } from './useTSDViewHouseFormInitializer';

interface EditHouseProps {
  consignmentForm: UseFormReturnType<TSDViewConsignmentFormValues>;
  houseConsignmentIdx?: number;
  isMaster: boolean;
  disabled: boolean;
  transportDisabled: boolean;
  onHide: () => void;
  onSave: (houseConsignment: TransitHouseConsignment, isMaster: boolean) => void;
}

export const EditHouse: React.FC<EditHouseProps> = ({ consignmentForm, houseConsignmentIdx, isMaster, onHide, onSave, disabled, transportDisabled }) => {
  const { houseForm, onSubmit } = useTSDViewHouseFormInitializer({ houseConsignmentIdx, consignmentForm, isMaster, onSave, onHide });

  const handleSave = () => {
    onSubmit();
  };

  return (
    <Stack px="md">
      <Tabs defaultValue="consignment">
        <Tabs.List>
          <Tabs.Tab value="consignment" data-pw="consignment-tab">
            Consignment
          </Tabs.Tab>
          <Tabs.Tab value="stakeholders" data-pw="stakeholders-tab">
            Stakeholders
          </Tabs.Tab>
          <Tabs.Tab value="transport" data-pw="transport-tab">
            Transport
          </Tabs.Tab>
          <Tabs.Tab value="documents" data-pw="documents-tab">
            Documents
          </Tabs.Tab>
          <Tabs.Tab value="batches" data-pw="batches-tab">
            Batches
          </Tabs.Tab>
        </Tabs.List>

        <Tabs.Panel value="consignment">
          <HouseCoreData houseForm={houseForm} disabled={disabled} />
        </Tabs.Panel>
        <Tabs.Panel value="stakeholders">
          <HouseStakeholders houseForm={houseForm} disabled={disabled} />
        </Tabs.Panel>
        <Tabs.Panel value="transport">
          <HouseTransport houseForm={houseForm} disabled={isMaster ? transportDisabled : disabled} />
        </Tabs.Panel>
        <Tabs.Panel value="documents">
          <HouseDocuments houseForm={houseForm} disabled={disabled} />
        </Tabs.Panel>
        <Tabs.Panel value="batches">
          <HouseBatches houseForm={houseForm} disabled={disabled} />
        </Tabs.Panel>
      </Tabs>
      <Box className={classes.footer}>
        <Button type="button" onClick={onHide} size="lg" variant="transparent">
          Cancel
        </Button>
        {!(isMaster ? transportDisabled : disabled) && (
          <Button type="button" variant="filled" size="lg" onClick={handleSave} data-pw="save-house-consignment-btn">
            Save
          </Button>
        )}
      </Box>
    </Stack>
  );
};
